import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../components/Button'
import Text from '../../../../components/Text'
import cx from 'classnames'
import styles from './DeleteCategoryModal.module.scss'
import { MediaCategory } from '../../../../types/Media'
import { useDeleteData } from '../../../../hooks/useDeleteData'
import { ApiRoutes } from '../../../../services/ApiService'
import { closeModal } from '../../../../services/ModalService'
import { showToast } from '../../../../services/ToastService'

type DeleteCategoryModalProps = {
    category: MediaCategory
    onSubmit: () => void
}

const DeleteCategoryModal: React.FC<DeleteCategoryModalProps> = ({
    category,
    onSubmit,
}) => {
    const { t } = useTranslation(['settings'])
    const { submit } = useDeleteData(ApiRoutes.MEDIA_CATEGORIES, category.id)

    const handleSubmit = () => {
        submit()
            .then((res) => {
                if (res.status === 200) {
                    showToast(t('categories.delete_modal.success'))
                    onSubmit()
                    closeModal()
                } else {
                    showToast(t('categories.delete_modal.error'), 'error')
                    closeModal()
                }
            })
            .catch(() => {
                showToast(t('categories.delete_modal.error'), 'error')
                closeModal()
            })
    }

    return (
        <div className={cx(styles['modal-wrapper'])}>
            <Text>
                {t('categories.delete_modal.sub_heading', {
                    category_name: category.name,
                })}
            </Text>
            <Button
                hierarchy={'primary'}
                text={t('categories.delete_modal.delete')}
                fn={() => handleSubmit()}
                classes={'zr-w-100 zr-mx-4 zr-my-2'}
            />
            <Button
                hierarchy={'secondary'}
                text={t('common.abort')}
                fn={() => closeModal()}
                classes={'zr-w-100 zr-mx-4 zr-my-2'}
            />
        </div>
    )
}

export default DeleteCategoryModal
